import { checkIsDateBefore, checkIsSameDay, isInspectionCancellableByState } from 'app/main/construction/inspections/helpers';

import { RolesWithPermissions } from '../';

export const DOB_INSPECTIONS_ROLES: RolesWithPermissions = {
  admin: {
    dobInspections: {
      view: true,
      create: false,
      update: false,
      delete: false,
      cancel: false,
    },
  },
  general: {
    dobInspections: {
      view: true,
      create: false,
      update: false,
      delete: false,
      cancel: false,
    },
  },
  supervisor: {
    dobInspections: {
      view: true,
      create: true,
      update: true,
      delete: true,
      cancel: true,
    },
  },
  backoffice: {
    dobInspections: {
      view: true,
      create: true,
      update: (currentUser, inspection) => !inspection.state?.includes('cancelled'),
      delete: true,
      cancel: (currentUser, inspection) => isInspectionCancellableByState(inspection),
      editPermits: (currentUser, inspection) => !inspection.state?.includes('cancelled'),
    },
  },
  client: {
    dobInspections: {
      view: true,
      create: true,
      update: (currentUser, inspection) =>
        !inspection.state?.includes('cancelled') && checkIsDateBefore(inspection.date),
      delete: false,
      cancel: (currentUser, inspection) =>
        isInspectionCancellableByState(inspection) && checkIsDateBefore(inspection.date),
      editPermits: (currentUser, inspection) =>
        !inspection.state?.includes('cancelled') && checkIsDateBefore(inspection.date),
    },
  },
  agency: {
    dobInspections: {
      view: true,
      create: false,
      update: false,
      delete: false,
      cancel: false,
    },
  },
  '3rd_inspector': {
    dobInspections: {
      view: true,
      create: false,
      update: false,
      delete: false,
      cancel: false,
    },
  },
  inspector: {
    dobInspections: {
      view: true,
      create: false,
      update: false,
      delete: false,
      cancel: (currentUser, inspection) =>
        isInspectionCancellableByState(inspection) && checkIsSameDay(inspection.date),
      editPermits: (currentUser, inspection) =>
        !inspection.state?.includes('cancelled') && checkIsSameDay(inspection.date),
    },
  },
};
